<template>
  <w-icon-wrapper
    :height='24'
    :width='20'
    icon-name='work-document-plus-icon'
    view-box='0 0 20 24'
  >
    <g
      id='_18_Dokument_Icon'
      data-name='18 Dokument_Icon'
      transform='translate(-2)'
    >
      <path
        id='Pfad_55678'
        d='M16,0H2V24H22V6Zm0,2.828L19.172,6H16ZM20,22H4V2H14V8h6Z'
        data-name='Pfad 55678'
        fill='currentColor'
      />
      <path
        id='Pfad_55679'
        d='M13,10.93a1,1,0,0,0-2,0v2H9a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0v-2h2a1,1,0,0,0,0-2H13Z'
        data-name='Pfad 55679'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDocumentPlus' };
</script>
